/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Svd_Pipeline_NoteInputs */

const en_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-stage execution pipeline`)
};

const ar_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خط تنفيذ من ${i?.count} مراحل`)
};

const bn_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-ধাপ এক্সিকিউশন পাইপলাইন`)
};

const de_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-stufige Ausführungspipeline`)
};

const es_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`canal de ejecución en etapa ${i?.count}`)
};

const fr_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} étapes`)
};

const pt_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`pipeline de execução de estágio ${i?.count}`)
};

const zh_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 级执行管道`)
};

const tr_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} aşamalı yürütme ardışık düzeni`)
};

const ru_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Конвейер выполнения этапов ${i?.count}`)
};

const pl_svd_pipeline_note = /** @type {(inputs: Svd_Pipeline_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-etapowy potok wykonania`)
};

/**
* | output |
* | --- |
* | "{count}-stage execution pipeline" |
*
* @param {Svd_Pipeline_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_pipeline_note = /** @type {((inputs: Svd_Pipeline_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_Pipeline_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_pipeline_note(inputs)
	if (locale === "bn") return bn_svd_pipeline_note(inputs)
	if (locale === "de") return de_svd_pipeline_note(inputs)
	if (locale === "es") return es_svd_pipeline_note(inputs)
	if (locale === "fr") return fr_svd_pipeline_note(inputs)
	if (locale === "pt") return pt_svd_pipeline_note(inputs)
	if (locale === "zh") return zh_svd_pipeline_note(inputs)
	if (locale === "tr") return tr_svd_pipeline_note(inputs)
	if (locale === "ru") return ru_svd_pipeline_note(inputs)
	if (locale === "pl") return pl_svd_pipeline_note(inputs)
	return en_svd_pipeline_note(inputs)
});